import { httpGet } from '@/services/http';
import { transformGuest, BackendGuest, FrontendGuest } from '@/services/transform';

/** GET /api/public/guests - 获取公开嘉宾列表 */
export async function getPublicGuests(): Promise<FrontendGuest[]> {
  try {
    const data = await httpGet<BackendGuest[]>('/public/guests');
    const guests = data.map(transformGuest);
    
    // Deduplicate by ID to prevent React key warnings
    const seen = new Set<string>();
    return guests.filter((g) => {
      if (seen.has(g.id)) return false;
      seen.add(g.id);
      return true;
    });
  } catch (error) {
    console.error('获取公开嘉宾列表失败:', error);
    return [];
  }
}

/** GET /api/public/guests/:id - 获取嘉宾详情 */
export async function getPublicGuestById(id: string): Promise<FrontendGuest | null> {
  try {
    const data = await httpGet<BackendGuest>(`/public/guests/${id}`);
    return transformGuest(data);
  } catch (error) {
    console.error('获取嘉宾详情失败:', error);
    return null;
  }
}
